import React, { Fragment } from "react";
import { shape, node, bool, any } from "prop-types";
import classNames from "classnames";

import ThemeConsumer from "../ThemeConsumer";

const BoxContent = ({
  theme,
  children,
  header,
  footer,
  scrollable,
  solicitation,
  modal,
  auto
}) => {
  const classes = classNames(
    { [theme.viewport]: scrollable },
    { [theme.surrounded]: scrollable && footer },
    { [theme.solicitation]: solicitation },
    { [theme.auto]: auto }
  );

  return (
    <Fragment>
      <section className={modal ? theme.modal : theme.content}>
        {header}
        <div className={classes}>{children}</div>
      </section>
      {footer && <footer>{footer}</footer>}
    </Fragment>
  );
};

BoxContent.propTypes = {
  children: node,
  header: node,
  footer: node,
  solicitation: bool,
  scrollable: bool,

  theme: shape({
    solicitation: any,
    auto: any
  })
};

BoxContent.defaultProps = {
  children: null,
  header: null,
  footer: null,
  auto: false,
  solicitation: false,
  scrollable: false,
  theme: {}
};

export default ThemeConsumer("UIBox")(BoxContent);



// WEBPACK FOOTER //
// ./src/shared/components/Box/BoxContent.js